export default __webpack_public_path__ + "static/media/CHM-Logo-white.89a0e53b.svg";